import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import { ReportEmailAddress } from 'dashboard/models/report/email-address';

interface EmailAddressProps {
  report: ReportEmailAddress;
  isRedacted: boolean;
}

export const EmailAddress = ({ report, isRedacted }: EmailAddressProps) => {
  const { 'email-address': emailAddress } = report.attributes;

  return (
    <>
      <AttributeGrid>
        <AttributeItem
          title='Email Address'
          value={emailAddress}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-email-address__email-address'
        />
      </AttributeGrid>
    </>
  );
};
